<template>
  <div class="page-login">
    <div class="login-wrapper">
      <div class="tabs">
        <div
          :class="['tab-item', { active: tab.name === activeTab }]"
          v-for="(tab, index) in tabs"
          :key="index"
          @click="activeTab = tab.name"
        >
          {{ tab.title }}
        </div>
      </div>

      <div class="code-container" v-show="activeTab == 'xy' && qrCodeShow">
        <div
          :class="['code-box', { 'is-error': codeStatus != 0 }]"
          v-loading="genLoading"
        >
          <img class="code-box__img" :src="qrCodeUrl" alt="" />
          <div class="status-layer" v-if="codeStatus == -1">
            <el-button
              class="status-layer__btn"
              type="primary"
              icon="el-icon-refresh-right"
              round
              :disabled="genLoading"
              @click="genQrCode"
              >重新获取</el-button
            >
            <p>获取二维码失败!</p>
          </div>
          <div class="status-layer" v-else-if="codeStatus == 1">
            <img
              class=""
              src="../../../static/20210517new/icon-success.png"
              alt=""
            />
            <p class="status-layer__suc">扫描成功</p>
            <p>请在手机上根据提示确认登录!</p>
          </div>
          <div class="status-layer" v-else-if="codeStatus == 3">
            <el-button
              class="status-layer__btn"
              type="primary"
              icon="el-icon-refresh-right"
              round
              :disabled="genLoading"
              @click="genQrCode"
              >刷新</el-button
            >
            <p>二维码已过期!</p>
          </div>
          <div class="status-layer" v-else-if="codeStatus == 4">
            <el-button
              class="status-layer__btn"
              type="primary"
              icon="el-icon-refresh-right"
              round
              :disabled="genLoading"
              @click="genQrCode"
              >刷新</el-button
            >
            <p>登录失败!</p>
          </div>
        </div>
        <div class="code-tips">
          <img
            class="code-tips__icon"
            src="../../../static/20210517new/icon-wechat.png"
            alt=""
          />
          微信扫一扫登录
        </div>
      </div>
      <div class="code-switch" v-if="activeTab == 'xy'">
        <span @click="qrCodeShow = !qrCodeShow">
          {{ qrCodeShow ? "账号密码登录" : "微信扫一扫登录" }}
        </span>
      </div>

      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        class="custom-form"
        label-width="100px"
        v-show="activeTab == 'jg' || !qrCodeShow"
      >
        <el-form-item prop="username" label="用户名">
          <el-input
            @keyup.enter.native="userKeyup"
            v-model="form.username"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密 码">
          <el-input
            ref="pwdInput"
            v-model="form.password"
            placeholder="请输入密码"
            show-password
            @keyup.enter.native="login"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="training == 1" label="培训类型">
          <el-select
            v-model="trainingValue"
            class="typeSel"
            @change="trainingChange"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in trainingList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button
          type="primary"
          :loading="isDisabled"
          style="padding: 15px 20px;width: 100%;font-size: 18px"
          @click="login"
          >登录</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  getInfo,
  getUnlimitedQRCode,
  getWxacodeStatus,
} from "@/apiCloud/login";
import { setToken, setExpiresIn, setTokenId } from "@/utilsCloud/auth";
export default {
  data() {
    return {
      visible: false,
      closed: false,
      tabs: [
        {
          title: "学员登录",
          name: "xy",
        },
        {
          title: "机构登录",
          name: "jg",
        },
      ],
      activeTab: "xy",
      qrCodeUrl: undefined,
      genLoading: false,
      codeStatus: 0, // 0未扫码 1已扫码 2登录成功 3已过期
      checkInterval: null, // 校验状态的定时器
      qrCodeShow: true,
      form: {
        username: "",
        password: "",
        entpId: "",
      },
      isDisabled: false,
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      isUserLogin: 0,
      trainingList: [
        {
          value: 0,
          label: "其他",
        },
        {
          value: 1,
          label: "职业技能工",
        },
      ],
      training: localStorage.getItem("training"),
      trainingValue: 0,
    };
  },
  created() {
    this.genQrCode();
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
      }
    },
    activeTab(val) {
      const errorStatus = [-1, 3, 4];
      if (val == "xy" && errorStatus.includes(this.codeStatus)) {
        this.genQrCode();
      }
    },
    qrCodeShow(val) {
      const errorStatus = [-1, 3, 4];
      if (val && errorStatus.includes(this.codeStatus)) {
        this.genQrCode();
      }
    },
  },
  methods: {
    genQrCode() {
      this.genLoading = true;
      getUnlimitedQRCode({ page: "pages/authorizedLogin/authorizedLogin" })
        .then((res) => {
          this.codeStatus = 0;
          this.qrCodeUrl = "data:image/png;base64," + res.data.qrcode;
          this.checkCodeStatus(res.data.uuid);
        })
        .catch((err) => {
          this.codeStatus = -1;
          console.error(err);
        })
        .finally(() => {
          this.genLoading = false;
        });
    },
    checkCodeStatus(uuid) {
      this.clearCheckInterval();
      this.checkInterval = setInterval(() => {
        getWxacodeStatus({ uuid })
          .then((res) => {
            const { status, token } = res.data;
            this.codeStatus = status;
            if (status != 0 && status != 1) {
              this.clearCheckInterval();
            }
            if (status == 2 && token) {
              setToken(token);
              setTokenId(token);
              this.$store.commit("SET_TOKEN", token);
              setExpiresIn(res.data.expires_in);
              this.$store.commit("SET_EXPIRES_IN", res.data.expires_in);
              this.$message.success("登录成功");
              this.afterLogin();
            }
          })
          .catch((err) => {
            console.error(err);
            this.codeStatus = 4;
            this.clearCheckInterval();
          });
      }, 3000);
    },
    clearCheckInterval() {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    },
    arrayBufferToBase64(buffer) {
      var binary = "";
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      console.log(window.btoa(binary));
      return window.btoa(binary);
    },
    //机构切换
    trainingChange() {
      console.log("dsd", this.trainingValue);
      localStorage.setItem("trainingValue", this.trainingValue);
    },
    checkUser(type) {
      this.isUserLogin = type;
      if (type == 1) {
        this.getWXQRCode();
      }
    },
    // 用户名回车
    userKeyup() {
      this.$refs.pwdInput.focus();
    },
    login() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.isDisabled = true;
          this.entpId = localStorage.getItem("enterpriseId");
          let data = {
            username: this.form.username,
            password: this.form.password,
            entpId: this.entpId,
            userType: "05",
            trainingValue: this.trainingValue,
          };
          this.$store
            .dispatch("Login", data)
            .then(() => {
              this.isDisabled = false;
              this.afterLogin();
              // if (res.data.userType == "01") {
              //   var eUrl = window.location.href;
              //   window.location.replace(
              //     eUrl.substring(0, eUrl.indexOf("/", 8)) + "/admin/index"
              //   );
              // } else {

              // }
            })
            .catch(() => {
              this.isDisabled = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    afterLogin() {
      getInfo().then((res) => {
        let user = res.user || {};
        if (user.userType == "05") {
          if (this.$route.fullPath == "/studyCentre") {
            this.$router.go(0);
          } else {
            this.$router.replace("/studyCentre");
          }
          this.close();
        } else {
          this.$router.go(0);
        }
      });
    },
    close() {
      this.closed = true;
    },
    getWXQRCode() {
      let redirectUri = encodeURIComponent(window.location.href);
      setTimeout(function () {
        var obj = new WxLogin({
          id: "wxcode", //wx组建元素

          appid: "wxbdc5610cc59c1631", //微信平台开放id

          scope: "snsapi_login",

          redirect_uri: "https%3A%2F%2Fpassport.yhd.com", //回调地址 encodeURIComponent编码

          state: "",

          style: "black", //黑白样式

          href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4OyBtYXJnaW46IDA7Ym9yZGVyOiBub25lO30KLmltcG93ZXJCb3ggLnBhbmVsQ29udGVudHt3aWR0aDogMjAwcHg7IGhlaWdodDogMjAwcHg7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQouaW1wb3dlckJveCAuaW5mbyB7ZGlzcGxheTogbm9uZTt9", //通过href base64加密css可以微调样式
        });
      }, 0);
    },
  },
  mounted() {},
  beforeDestroy() {
    this.clearCheckInterval();
    console.log("beforeDestroy");
  },
};
</script>
<style lang="less" scoped>
@login-them: #0071fb;
.page-login {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: #fff url("~@/assets/images/login-bg.png") no-repeat center top;
  background-size: cover;
}
.login-wrapper {
  position: absolute;
  width: 606px;
  height: 540px;
  background: #ffffff;
  box-shadow: 0px 5px 8px 2px rgba(0, 22, 57, 0.3);
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .tabs {
    width: 365px;
    display: flex;
    justify-content: space-between;
    margin-top: 55px;
    margin-bottom: 50px;
    .tab-item {
      position: relative;
      font-weight: bold;
      font-size: 30px;
      color: #666666;
      line-height: 1;
      cursor: pointer;
      &.active {
        color: #3686ff;
        &:after {
          position: absolute;
          content: "";
          bottom: -20px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #3686ff;
        }
      }
    }
  }

  .code-container {
    position: relative;
    width: 270px;
    .code-box {
      position: relative;
      width: 270px;
      height: 270px;
      border-radius: 20px;
      border: 3px solid #3686ff;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      &__img {
        width: 240px;
        height: 240px;
        display: block;
      }
      &.is-error {
        border-color: rgba(244, 244, 244, 0.96);
      }
      .status-layer {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.96);
        line-height: 1;
        &__suc {
          font-size: 18px;
          color: #333333;
          margin-top: 24px;
          margin-bottom: 15px;
          & + p {
            font-size: 14px;
            color: #666666;
          }
        }
        &__btn {
          padding: 8px 24px;
          font-size: 18px;
          & + p {
            font-size: 18px;
            color: #333333;
            margin-top: 16px;
          }
        }
      }
    }
    .code-tips {
      color: #666666;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
      &__icon {
        width: 22px;
        display: block;
      }
    }
  }
  .code-switch {
    position: absolute;
    bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    line-height: 1;
    span {
      color: #3686ff;
      cursor: pointer;
    }
  }

  .login-btn {
    margin-top: 35px;
    width: 100%;
  }
  /deep/ .icon-input {
    display: block;
    background: no-repeat center;
    background-size: 18px;
  }
  /deep/ .icon-user {
    background-image: url("../../../static/20210517new/username.png");
  }
  /deep/ .el-input__inner:focus + .el-input__prefix .icon-user {
    background-image: url("../../../static/20210517new/username_active.png");
  }
  /deep/ .icon-pwd {
    background-image: url("../../../static/20210517new/password.png");
  }
  /deep/ .el-input__inner:focus + .el-input__prefix .icon-pwd {
    background-image: url("../../../static/20210517new/password_active.png");
  }
}
.custom-form {
  /deep/ .el-form-item {
    width: 365px;
    .el-form-item__label {
      font-size: 18px;
      line-height: 60px;
    }
    .el-form-item__content {
      line-height: 60px;
      font-size: 16px;
      .el-input__inner{
        line-height: 45px;
        height: 45px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/login/login.vue